// FILE: ProjectAvatar.logic.ts
// Purpose: Build project icon URLs and fallback presentation values.

import type { ProjectId } from "@taskin-code/contracts";

import { resolveProjectColor } from "~/lib/projectIdentity";
import { resolveServerHttpOrigin } from "~/lib/serverOrigin";

export function projectIconSrc(input: {
  readonly projectId: ProjectId;
  readonly iconFileName: string | null | undefined;
}): string | null {
  const fileName = input.iconFileName?.trim();
  if (!fileName) return null;
  const origin = resolveServerHttpOrigin().replace(/\/+$/, "");
  return `${origin}/api/projects/${encodeURIComponent(input.projectId)}/icon?v=${encodeURIComponent(fileName)}`;
}

export function projectAvatarFallbackStyle(project: {
  readonly name: string;
  readonly color?: string | null;
}): { readonly backgroundColor: string; readonly color: string } {
  return { backgroundColor: resolveProjectColor(project), color: "hsl(0 0% 100%)" };
}
